import { Ride } from '@geovelo-frontends/commons';
import { Avatar, Box, Card, CardActions, CardContent, Skeleton, Typography } from '@mui/material';
import { Link } from 'gatsby';
import React, { useContext, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import Button from '../../components/button';
import { AppContext } from '../../context';

import PartnerTerritory from './partner-territory';

function Creator({
  partnersGeogroups,
  ride,
}: {
  partnersGeogroups: { [key: number]: { id: number } };
  ride: Ride | undefined;
}): JSX.Element {
  const [partner, setPartner] = useState<
    Partial<{
      code: string;
      icon: string;
      id: number;
      title: string;
    }>
  >();
  const {
    user: { current: currentUser },
  } = useContext(AppContext);
  const {
    t,
    i18n: { language: currentLanguage },
  } = useTranslation();

  useEffect(() => {
    if (ride) {
      setPartner(
        ride.partners?.find(({ id, code }) => code !== 'geovelo' && id && partnersGeogroups[id]) ||
          ride.partners?.find(({ code }) => code === 'geovelo'),
      );
    }
  }, [ride]);

  if (ride?.creator && !partner && currentUser && currentUser.id === ride.creator.id) return <></>;

  return (
    <Card sx={{ borderRadius: 4 }} variant="outlined">
      <CardContent sx={{ '&&': { display: 'flex', flexDirection: 'column', gap: 2, padding: 2 } }}>
        <Typography fontWeight={600}>{t('geovelo.rides.detail.created_by')}</Typography>
        <Box alignItems="center" display="flex" gap={2}>
          {ride ? (
            <Avatar src={partner?.icon} sx={{ height: 64, width: 64 }} />
          ) : (
            <Skeleton height={64} variant="circular" width={64} />
          )}
          <Box display="flex" flexDirection="column" gap={1}>
            <Typography variant="body2">
              {ride ? (
                t('geovelo.rides.detail.created_on', {
                  creator: partner ? partner.title : ride.creator?.username,
                  date: ride.created?.format('LL'),
                })
              ) : (
                <Skeleton variant="text" width={200} />
              )}
            </Typography>
            <PartnerTerritory partner={partner} />
          </Box>
        </Box>
      </CardContent>
      {partner?.id && partnersGeogroups[partner.id] && (
        <CardActions>
          <Button
            color="primary"
            component={Link}
            size="small"
            to={`/${currentLanguage}/communities/${partnersGeogroups[partner.id].id}`}
            variant="outlined"
          >
            {t('geovelo.rides.detail.actions.view_creator_rides')}
          </Button>
        </CardActions>
      )}
    </Card>
  );
}

export default Creator;
